import React, { type CSSProperties, type JSX } from 'react';

import styled, { css } from 'styled-components';
import { isLoadingSelector } from '@/app/common/css/selectors.ts';

type LoadLineProps = {
  listView?: boolean | null;
  addMargin?: boolean | null;
  style?: CSSProperties;
  isDP?: boolean;
  $isGlobal?: boolean;
};

const LoadLineContainer = styled.div<{
  listView?: boolean | null;
  addMargin?: boolean | null;
  isDP?: boolean;
  $isGlobal?: boolean;
}>`
  margin-top: 0;
  height: 3px;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  top: unset;
  overflow: hidden;

  ${({ addMargin }) =>
    addMargin &&
    css`
      @media (min-width: 1024px) {
        margin-top: 18px;
      }
    `}

  ${({ $isGlobal }) =>
    $isGlobal &&
    css`
      display: none;

      ${isLoadingSelector} & {
        display: block;
      }
    `}
`;

const LoadLineContent = styled.div`
  height: 3px;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  will-change: transform;
  -webkit-animation: LoadingLine-shift 1.5s cubic-bezier(0.65, 0.05, 0.36, 1);
  animation: LoadingLine-shift 1.5s cubic-bezier(0.65, 0.05, 0.36, 1);
  animation-iteration-count: infinite;
`;

const LoadLine = ({ listView, addMargin, style, isDP, $isGlobal }: LoadLineProps): JSX.Element => (
  <LoadLineContainer listView={listView} style={style} addMargin={addMargin} isDP={isDP} $isGlobal={$isGlobal}>
    <LoadLineContent />
  </LoadLineContainer>
);

export default LoadLine;
